module.exports = __webpack_public_path__ + "img/313.efa3f6c9.png";